export const onResize = () => {
	try {
		const navSpace = document.getElementsByClassName("topNavLeft")[0] as HTMLElement;
		const navSpaceWidth = navSpace.offsetWidth;
		if (navSpace.style.display === "none" || navSpaceWidth === 0) { return; }

		const navLinks = navSpace.getElementsByClassName("topNavLeftLinks")[0] as HTMLElement;
		const links = Array.from(navLinks.getElementsByTagName("a")) as HTMLElement[];
		const overflow = navSpace.getElementsByClassName("topNavOverflow")[0] as HTMLElement;
		const overflowLinkContainer = overflow.getElementsByClassName("topNavOverflowLinks")[0] as HTMLElement;
		const overflowLinks = Array.from(overflowLinkContainer.getElementsByTagName("a")) as HTMLElement[];

		let linkWidth = [...links, overflow].map(link => link.getBoundingClientRect().width).reduce((a, b) => a + b, 0) + 50;

		if (linkWidth > navSpaceWidth) {
			while (linkWidth > navSpaceWidth) {
				const lastLink = links.pop();
				if (!lastLink) { break; }
				const lastLinkWidth = lastLink.getBoundingClientRect().width;
				lastLink.dataset.linkWidth = lastLinkWidth + "";
				overflowLinkContainer.prepend(lastLink);
				linkWidth -= lastLinkWidth;
			}
			overflow.style.display = "block";
		}
		else {
			while (linkWidth <= navSpaceWidth) {
				if (overflowLinks.length === 0) { break; }
				const firstLink = overflowLinks[0];
				const firstLinkWidth = parseInt(firstLink.dataset.linkWidth ?? "0");
				if (firstLinkWidth === 0) { break; }
				linkWidth += firstLinkWidth;
				if (navSpaceWidth > linkWidth) {
					navLinks.append(firstLink);
				}
			}
			if (overflowLinkContainer.children.length === 0) {
				overflow.style.display = "none";
			}
		}
	}
	catch (e) {
		console.error("Failed to resize nav bar", e);
	}
}